export const MATCH_TIERS = {
  EXCELLENT: 'Excellent',
  STRONG: 'Strong',
  POTENTIAL: 'Potential',
}
